const SearchIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    className="search-icon"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#1D1D1B"
      fillRule="evenodd"
      d="M19.33 5.22a6.75 6.75 0 0 1-8.99 10.05L4.3 21.3l-1.06-1.06 6.04-6.04a6.75 6.75 0 0 1 10.05-8.99Zm-1.06 1.06a5.25 5.25 0 1 0-7.43 7.43 5.25 5.25 0 0 0 7.43-7.43Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SearchIcon;
